import { setSearchTerm } from "../productsDataReducer";
import { useSearch } from "../../../../core/util/storeHooks";

export const useProductSearch = () => useSearch(s => s.data.listing.products.searchTerm, setSearchTerm);
